const PRIVILEGES_LS = "team_privileges_v1";

export interface PrivilegesData {
  partners: string[];
  admins: string[];
  integrations: Record<string, string[]>;
}

export function loadPrivileges(): PrivilegesData {
  try {
    const raw = localStorage.getItem(PRIVILEGES_LS);
    if (!raw) return { partners: [], admins: [], integrations: {} };
    return JSON.parse(raw);
  } catch {
    return { partners: [], admins: [], integrations: {} };
  }
}

export function savePrivileges(data: PrivilegesData): void {
  localStorage.setItem(PRIVILEGES_LS, JSON.stringify(data));
}
